

<template>
  <!-- Topbar Start -->
  <div class="navbar-custom">
    <ul class="list-unstyled topnav-menu float-right mb-0">
      <b-nav-item-dropdown right class="notification-list" menu-class="profile-dropdown">
        <template slot="button-content">
          <div class="nav-user mr-0">
            <img src="@assets/images/logo-sm.png" alt="payra logo" class="rounded-circle" />
            <span class="pro-user-name ml-1" v-if="Object.keys(user).length !== 0">
              {{ user ? user.name : '' }}
              <i class="mdi mdi-chevron-down"></i>
            </span>
          </div>
        </template>

        <b-dropdown-item href="/user/profile">
          <i class="fe-user mr-1"></i>
          <span>My Account</span>
        </b-dropdown-item>

        <b-dropdown-item href="/user/password/update">
          <i class="fe-settings mr-1"></i>
          <span>Change Password</span>
        </b-dropdown-item>

        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item href="/logout">
          <i class="fe-log-out mr-1"></i>
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </ul>

    <!-- LOGO -->
    <div class="logo-box">
      <a href="#" class="logo text-center">
        <span class="logo-lg">
          <img src="@assets/images/logo-sm.png" class="rounded-circle" alt="payra logo" height="40" />
          <!-- <span class="logo-lg-text-light">Xeria</span> -->
        </span>
        <span class="logo-sm">
          <!-- <span class="logo-sm-text-dark">X</span> -->
          <img src="@assets/images/logo-sm.png" class="rounded-circle" alt="payra logo" height="24" />
        </span>
      </a>
    </div>

    <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
      <li>
        <button class="button-menu-mobile" @click="toggleMenu">
          <i class="fe-menu"></i>
        </button>
      </li>

      <!-- <b-nav-item-dropdown class="custom-dropdown d-none d-lg-block">
        <template slot="button-content">
          Trade
          <i class="mdi mdi-chevron-down"></i>
        </template>
        <b-dropdown-item v-for="(trade, index) in trades" :key="index" href="#">
          <i class="fe-bar-chart-line- mr-1"></i>
          <router-link :to="{ name: 'tradeHome', params: { trade_id: trade.id } }">{{ trade.desc }}</router-link>
        </b-dropdown-item>
      </b-nav-item-dropdown> -->
    </ul>

    <div class="nav-project-name">
      <span>Training Management System</span>
    </div>
  </div>
  <!-- end Topbar -->
</template>
<script>
import { authComputed } from '@state/helpers'
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import http from "@state/http";
import store from "../state/store";

export default {
  components: { VuePerfectScrollbar },
  data() {
    return {
      user: {},
      trades: []
    }
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    if (store.getters['auth/loggedIn']) {
      this.getUserProfile();
      //this.getChartTrade();
    }
  },

  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },

    getUserProfile() {
      http.get("api/user/profile")
        .then(resource => {
          this.user = resource.data.user
          if (this.user.is_password_change === 1) {
            // this.$router.push("/logout");
            this.$router.push({ name: "updatePassword" });
          }
        })
        .catch()
    },
    getChartTrade() {
      http.get("api/getChartTrade")
        .then(resource => {
          this.trades = resource.data.trades
        })
        .catch()
    }
  },
}
</script>
<style lang="scss">
.noti-scroll {
  height: 220px;
}

.ps>.ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}

.ps>.ps__scrollbar-y-rail>.ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail>.ps__scrollbar-y,
.ps>.ps__scrollbar-y-rail:active>.ps__scrollbar-y,
.ps>.ps__scrollbar-y-rail:hover>.ps__scrollbar-y {
  width: 6px !important;
}

.button-menu-mobile {
  outline: none !important;
}

.custom-dropdown .dropdown-menu {
  max-height: 300px;
  overflow: auto;
}

.nav-project-name {
  display: flex;
  align-items: center;
  height: 70px;
  font-size: 20px;
  color: #fff;
}
</style>
